import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleType } from '../../services/http/vehicles/vehicles.interface';

@Component({
  selector: 'app-vehicle-type-tag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vehicle-type-tag.component.html',
  styleUrl: './vehicle-type-tag.component.scss'
})
export class VehicleTypeTagComponent {
  @Input() vehicleType: VehicleType | undefined;
}
